import type { DeviceViewEntityTabMouseEvent } from 'components/DeviceView/DeviceViewHeader';
import type {
  DeviceViewEdgeEntity,
  DeviceViewEntity,
  DeviceViewNodeEntity,
} from 'components/DeviceView/deviceViewTypes';
import { isDeviceViewEdgeStructure } from 'components/DeviceView/helpers/isDeviceViewEdgeStructure';
import { isDeviceViewNodeStructure } from 'components/DeviceView/helpers/isDeviceViewNodeStructure';
import {
  EDGE_HIGHLIGHT_COLOR,
  EDGE_HIGHLIGHT_THICKNESS,
} from 'components/Graph/constants';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { highlightEdge } from '../edges/highlightEdge';
import { highlightGraphNode } from '../pathLookup/highlightGraphNode';

export const highlightPathLookupPathInspectorElement: GraphCommandFactory<
  DeviceViewEntityTabMouseEvent
> = (cmdContext, dispatch) => async (command) => {
  if (isDeviceViewNodeStructure(command)) {
    const deviceViewEntity = cmdContext
      .getDeviceView()
      .deviceViewEntities.find(
        (entity: DeviceViewEntity): entity is DeviceViewNodeEntity =>
          entity.deviceViewElement === 'node' &&
          entity.id === command.deviceViewEntityId,
      );
    if (deviceViewEntity !== undefined) {
      dispatch(highlightGraphNode, { nodeSn: deviceViewEntity.sn });
    }
  } else if (isDeviceViewEdgeStructure(command)) {
    const deviceViewEntity = cmdContext
      .getDeviceView()
      .deviceViewEntities.find(
        (entity: DeviceViewEntity): entity is DeviceViewEdgeEntity =>
          entity.deviceViewElement === 'edge' &&
          entity.id === command.deviceViewEntityId,
      );
    if (deviceViewEntity !== undefined) {
      dispatch(highlightEdge, {
        edgeId: deviceViewEntity.edgeId,
        color: EDGE_HIGHLIGHT_COLOR,
        thickness: EDGE_HIGHLIGHT_THICKNESS,
      });
    }
  }
};
